import { render, staticRenderFns } from "./orderItemIcon.vue?vue&type=template&id=5a1f381c&scoped=true&"
import script from "./orderItemIcon.vue?vue&type=script&lang=js&"
export * from "./orderItemIcon.vue?vue&type=script&lang=js&"
import style0 from "./orderItemIcon.vue?vue&type=style&index=0&id=5a1f381c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f381c",
  null
  
)

export default component.exports